import { Calendar, Check } from 'lucide-react';
import { Button } from '../components/ui/button';
import SEO from '../components/SEO';

const BOOKING_URL = "https://home.shortcutssoftware.com/ah#/_h/sites/6509/details";

const team = [
  { position: 'Executive Director', names: ['Paige'] },
  { position: 'Creative Director', names: ['Josie'] },
  { position: 'Principal Stylist', names: ['Graham'] },
  { position: 'Senior Stylist', names: ['Michelle'] },
  { position: 'Emerging Stylist', names: ['Coming Soon'] },
];

const serviceCategories = [
  {
    title: 'Haircuts',
    services: [
      { name: 'Ladies Cut', emerging: null, senior: '$113', principal: '$147', director: '$165' },
      { name: 'Uni Student - Ladies', emerging: null, senior: '$105', principal: '$135', director: null },
      { name: 'High School', emerging: null, senior: '$95', principal: null, director: null },
      { name: 'Primary School', emerging: null, senior: '$60', principal: null, director: null },
      { name: 'Pre School', emerging: null, senior: '$50', principal: null, director: null },
      { name: 'Mens Cut', emerging: null, senior: '$85', principal: '$90', director: null },
    ]
  },
  {
    title: 'Styling',
    services: [
      { name: 'Short Blow Wave (above shoulders)', emerging: '$56', senior: '$63', principal: '$68', director: '$75' },
      { name: 'Medium Blow Wave (shoulder length)', emerging: '$63', senior: '$71', principal: '$76', director: '$83' },
      { name: 'Long Blow Wave (below shoulders)', emerging: '$70', senior: '$80', principal: '$85', director: '$90' },
      { name: 'Express Irons/Straightening (pre-washed)', emerging: '$45', senior: '$55', principal: null, director: null },
      { name: 'Express Curls/Tongs (pre-washed)', emerging: '$45', senior: '$55', principal: null, director: null },
      { name: 'Upstyle', emerging: null, senior: 'From $90', principal: null, director: null },
      { name: 'Bridal Upstyle', emerging: null, senior: 'POA', principal: null, director: null },
    ]
  },
  {
    title: 'Colour - Semi Permanent / Gloss',
    services: [
      { name: 'Short', emerging: 'From $90', senior: 'From $125', principal: 'From $132', director: 'From $140' },
      { name: 'Medium', emerging: 'From $100', senior: 'From $140', principal: 'From $147', director: 'From $155' },
      { name: 'Long', emerging: 'From $115', senior: 'From $165', principal: 'From $173', director: 'From $185' },
    ]
  },
  {
    title: 'Colour - Permanent / Regrowth',
    services: [
      { name: 'Regrowth', emerging: 'From $92', senior: 'From $132', principal: 'From $138', director: 'From $145' },
      { name: 'Regrowth & Refresh Ends - Short', emerging: 'From $119', senior: 'From $170', principal: 'From $178', director: 'From $190' },
      { name: 'Regrowth & Refresh Ends - Medium', emerging: 'From $126', senior: 'From $180', principal: 'From $189', director: 'From $200' },
      { name: 'Regrowth & Refresh Ends - Long', emerging: 'From $133', senior: 'From $190', principal: 'From $199', director: 'From $210' },
      { name: 'Hi-Lift Tint', emerging: 'From $112', senior: 'From $160', principal: 'From $168', director: 'From $180' },
    ]
  },
  {
    title: 'Colour - Full Head Bleach',
    services: [
      { name: 'Regrowth', emerging: null, senior: 'From $250', principal: 'From $262', director: 'From $275' },
      { name: 'Regrowth + Ends', emerging: null, senior: 'From $320', principal: 'From $336', director: 'From $355' },
      { name: 'Virgin Application', emerging: null, senior: 'From $375', principal: 'From $393', director: 'From $415' },
    ]
  },
  {
    title: 'Balayage / Teasy Lights',
    services: [
      { name: 'Face Frame + Refresh', emerging: null, senior: 'From $300', principal: null, director: 'From $345' },
      { name: '½ Head', emerging: null, senior: 'From $450', principal: null, director: 'From $515' },
      { name: 'Full Head Regrowth', emerging: null, senior: 'From $485', principal: null, director: 'From $575' },
      { name: 'Full Head', emerging: null, senior: 'From $575', principal: null, director: 'From $660' },
    ]
  },
  {
    title: 'Traditional Foils',
    services: [
      { name: '¼ Head', emerging: 'From $119', senior: 'From $170', principal: 'From $178', director: 'From $190' },
      { name: '½ Head', emerging: 'From $168', senior: 'From $240', principal: 'From $252', director: 'From $265' },
      { name: '¾ Head', emerging: null, senior: 'From $280', principal: 'From $294', director: 'From $310' },
      { name: 'Full Head', emerging: null, senior: 'From $330', principal: 'From $346', director: 'From $365' },
    ]
  },
  {
    title: 'Tint & Foils Combined',
    services: [
      { name: 'Tint + ¼ Head Foils', emerging: 'From $161', senior: 'From $230', principal: 'From $241', director: 'From $255' },
      { name: 'Tint + ½ Head Foils', emerging: 'From $199', senior: 'From $285', principal: 'From $299', director: 'From $315' },
      { name: 'Tint + ¾ Head Foils', emerging: null, senior: 'From $305', principal: 'From $320', director: 'From $335' },
      { name: 'Tint + Full Head Foils', emerging: null, senior: 'From $350', principal: 'From $367', director: 'From $385' },
    ]
  },
  {
    title: 'Hair Extensions',
    services: [
      { name: 'Keratin Bond Extensions', emerging: null, senior: 'POA', principal: null, director: null },
      { name: 'Tape Extensions', emerging: null, senior: 'POA', principal: null, director: null },
      { name: 'Weft Extensions', emerging: null, senior: 'POA', principal: null, director: null },
      { name: 'Extensions Maintenance', emerging: null, senior: 'POA', principal: null, director: null },
      { name: 'Extensions Removal', emerging: null, senior: 'POA', principal: null, director: null },
    ]
  },
  {
    title: 'Treatments',
    services: [
      { name: 'Express Treatment', emerging: null, senior: 'From $25', principal: null, director: null },
      { name: 'Intensive Treatment', emerging: null, senior: 'From $35', principal: null, director: null },
      { name: 'K18 Bond Rebuilder', emerging: null, senior: '$60', principal: null, director: null },
      { name: 'Keratin Smoothing - Short', emerging: 'From $285', senior: 'From $385', principal: null, director: 'From $425' },
      { name: 'Keratin Smoothing - Medium', emerging: 'From $395', senior: 'From $495', principal: null, director: 'From $545' },
      { name: 'Keratin Smoothing - Long', emerging: 'From $505', senior: 'From $605', principal: null, director: 'From $665' },
    ]
  },
];

const galleryImages = [
  'https://customer-assets.emergentagent.com/job_d95e4940-e0b0-4d59-9b4c-c960d9d6604f/artifacts/xyajkibl_PXL_20260213_225135652.RAW-01.COVER.jpg',
  'https://customer-assets.emergentagent.com/job_1dc100c1-fd6e-4e96-8e6a-366ccfb0323b/artifacts/admh8tm3_blonde%202%20lab.png',
  'https://customer-assets.emergentagent.com/job_d95e4940-e0b0-4d59-9b4c-c960d9d6604f/artifacts/54fmygeu_PXL_20260213_224748405.RAW-01.MP.COVER.jpg',
  'https://customer-assets.emergentagent.com/job_d95e4940-e0b0-4d59-9b4c-c960d9d6604f/artifacts/kcgwspdb_PXL_20260213_225736537.RAW-01.COVER.jpg',
];

export default function HairServices() {
  return (
    <main className="min-h-screen bg-[#FFFDF9]" data-testid="hair-services-page">
      <SEO page="hair" />
      {/* Hero Section */}
      <section className="pt-32 pb-16 md:pt-40 md:pb-20 text-center" data-testid="hair-hero">
        <div className="max-w-[1200px] mx-auto px-6">
          <h1 className="text-5xl md:text-7xl font-light text-[#2C2420] tracking-wide mb-6">
            Hair Service List
          </h1>
          <p className="text-lg text-[#6B5D4D] mb-8">
            Established in 1978. Camberwell's premier hair destination.
          </p>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
            <Button 
              className="bg-[#8D7B68] hover:bg-[#6B5D4D] text-white rounded-full px-8 py-4 text-base"
              data-testid="hair-book-btn"
            >
              <Calendar className="w-5 h-5 mr-2" />
              Book Appointment
            </Button>
          </a>
        </div>
      </section>

      {/* Why Choose Us */}
      <section className="py-16 bg-[#D4C4B0]/20">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-4 gap-8 text-center">
            <div>
              <p className="text-3xl font-medium text-[#8D7B68] mb-2">45+</p>
              <p className="text-[#5D4A3A]">Years Experience</p>
            </div>
            <div>
              <p className="text-3xl font-medium text-[#8D7B68] mb-2">800+</p>
              <p className="text-[#5D4A3A]">Happy Clients</p>
            </div>
            <div>
              <p className="text-3xl font-medium text-[#8D7B68] mb-2">100%</p>
              <p className="text-[#5D4A3A]">Sustainable Salon</p>
            </div>
            <div>
              <p className="text-3xl font-medium text-[#8D7B68] mb-2">4.5★</p>
              <p className="text-[#5D4A3A]">Google Rating</p>
            </div>
          </div>
        </div>
      </section>

      {/* The Team Table */}
      <section className="py-12 border-b border-[#E8DED2]">
        <div className="max-w-[1200px] mx-auto px-6">
          <h2 className="text-xs uppercase tracking-[0.3em] text-[#8D7B68] mb-8 text-center">The Team</h2>
          <div className="overflow-x-auto">
            <table className="w-full text-sm">
              <tbody>
                {team.map((row) => (
                  <tr key={row.position} className="border-b border-[#E8DED2]/50 last:border-0">
                    <td className="py-3 pr-8 text-[#8D7B68] font-medium whitespace-nowrap w-48">{row.position}</td>
                    <td className="py-3 text-[#2C2420]">
                      {row.names.join(' · ')}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </section>

      {/* Image Gallery */}
      <section className="py-12">
        <div className="max-w-[1400px] mx-auto px-6">
          <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
            {galleryImages.map((img, idx) => (
              <div key={idx} className="aspect-square overflow-hidden">
                <img 
                  src={img} 
                  alt={`Artistry House salon ${idx + 1}`}
                  className="w-full h-full object-cover hover:scale-105 transition-transform duration-500"
                />
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Service Tables */}
      <section className="py-12" data-testid="hair-services-list">
        <div className="max-w-[1000px] mx-auto px-6">
          {serviceCategories.map((category) => (
            <div key={category.title} className="mb-8" data-testid={`service-category-${category.title.toLowerCase().replace(/\s+/g, '-')}`}>
              <div className="mb-3">
                <h3 className="text-xl md:text-2xl font-light text-[#2C2420]">{category.title}</h3>
              </div>

              <div className="overflow-x-auto">
                <table className="w-full">
                  <thead>
                    <tr className="border-b-2 border-[#2C2420]">
                      <th className="text-left py-2 pr-2 text-xs uppercase tracking-[0.15em] text-[#8D7B68] font-medium">Service</th>
                      <th className="text-right py-2 px-2 text-xs uppercase tracking-[0.15em] text-[#8D7B68] font-medium">Emerging</th>
                      <th className="text-right py-2 px-2 text-xs uppercase tracking-[0.15em] text-[#8D7B68] font-medium">Senior</th>
                      <th className="text-right py-2 px-2 text-xs uppercase tracking-[0.15em] text-[#8D7B68] font-medium">Principal</th>
                      <th className="text-right py-2 pl-2 text-xs uppercase tracking-[0.15em] text-[#8D7B68] font-medium">Director</th>
                    </tr>
                  </thead>
                  <tbody>
                    {category.services.map((service, idx) => (
                      <tr 
                        key={service.name} 
                        className={`border-b border-[#E8DED2] hover:bg-[#F5F0EB] transition-colors ${idx % 2 === 0 ? 'bg-white' : 'bg-[#FDFBF9]'}`}
                      >
                        <td className="py-2.5 pr-2 text-[#2C2420] text-sm">{service.name}</td>
                        <td className="py-2.5 px-2 text-right text-[#6B5D4D] text-sm">{service.emerging || '—'}</td>
                        <td className="py-2.5 px-2 text-right text-[#6B5D4D] text-sm">{service.senior || '—'}</td>
                        <td className="py-2.5 px-2 text-right text-[#6B5D4D] text-sm">{service.principal || '—'}</td>
                        <td className="py-2.5 pl-2 text-right text-[#6B5D4D] text-sm">{service.director || '—'}</td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ))}

          <div className="mt-8 p-6 bg-[#F5F0EB] rounded-lg text-center">
            <p className="text-sm text-[#6B5D4D]">
              POA = Price on Application. All cuts include consultation, shampoo and blowdry.
            </p>
          </div>

          <div className="mt-12 text-center">
            <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
              <Button className="bg-[#2C2420] hover:bg-[#1a1512] text-white rounded-full px-10 py-5 text-base">
                Book Your Appointment
              </Button>
            </a>
          </div>
        </div>
      </section>

      {/* What We Use - Premium Products */}
      <section className="py-24 md:py-32 bg-[#D4C4B0]/20">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-16 items-center">
            <div>
              <p className="text-sm uppercase tracking-widest text-[#8D7B68] mb-4">Premium Products</p>
              <h2 className="text-4xl md:text-5xl font-medium text-[#2C2420] mb-6">
                Quality You Can Trust
              </h2>
              <p className="text-lg text-[#5D4A3A] leading-relaxed mb-6">
                We use only the finest professional products including La Biosthetique and BHAVE to ensure your hair receives the best care possible.
              </p>
              <ul className="space-y-4">
                {['La Biosthetique Professional Range', 'BHAVE Keratin Treatments', 'K18 Molecular Repair', 'Great Lengths Extensions', 'Cezanne Keratin Smoothing', 'Sustainable & Eco-Friendly Options'].map((item) => (
                  <li key={item} className="flex items-center gap-3 text-[#3D352D]">
                    <div className="w-6 h-6 rounded-full bg-[#D4C4B0]/50 flex items-center justify-center">
                      <Check className="w-4 h-4 text-[#8D7B68]" />
                    </div>
                    {item}
                  </li>
                ))}
              </ul>
            </div>
            <div className="aspect-square rounded-lg overflow-hidden">
              <img 
                src="https://customer-assets.emergentagent.com/job_d95e4940-e0b0-4d59-9b4c-c960d9d6604f/artifacts/jhvoy2i3_GHD.webp"
                alt="GHD professional hair tools - Australia's #1 hair tool brand"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* CTA - Ready for a New Look */}
      <section className="py-24 md:py-32 bg-[#2C2420]">
        <div className="max-w-[1600px] mx-auto px-6 md:px-12 lg:px-24 text-center">
          <h2 className="text-4xl md:text-5xl font-medium text-white mb-6">
            Ready for a New Look?
          </h2>
          <p className="text-lg text-[#BCAAA4] max-w-2xl mx-auto mb-8">
            Book your hair appointment today and let our expert stylists transform your look.
          </p>
          <a href={BOOKING_URL} target="_blank" rel="noopener noreferrer">
            <Button className="bg-[#8D7B68] hover:bg-[#6B5D4D] text-white rounded-full px-10 py-6 text-lg">
              <Calendar className="w-5 h-5 mr-2" />
              Book Hair Appointment
            </Button>
          </a>
        </div>
      </section>
    </main>
  );
}
